import { history } from "../../src/index";

import * as types from '../constants/archivedetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as archivedetailsApi from '../api/archivedetails';

export function getArchiveDetailsList(committee_id) {
    // console.log("getArchiveDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ARCHIVE_LIST_REQUEST });
        archivedetailsApi.getArchiveList(committee_id)
            .then(function (response) {
                // console.log("getArchiveDetailsList", response)
                dispatch({ type: types.FETCH_ARCHIVE_LIST_REQUEST_COMPLETED, data: response.data && response.data.name ? null : response.data });
            })
            .catch(function (err) {
                // console.log("getArchiveDetailsList Error", err)
                dispatch({ type: types.FETCH_ARCHIVE_LIST_REQUEST_ERROR });
            });
    }
}

export function getArchiveAgendaDetailsList(id) {
    // console.log("getArchiveDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ARCHIVE_REQUEST });
        archivedetailsApi.getArchiveAgendaList(id)
            .then(function (response) {
                // console.log("getArchiveDetails", response)
                dispatch({ type: types.FETCH_ARCHIVE_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getArchiveDetails Error", err)
                dispatch({ type: types.FETCH_ARCHIVE_REQUEST_ERROR });
            });
    }
}

export function deleteArchiveDetails(id) {
    // console.log("deleteArchiveDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ARCHIVE_REQUEST });
        archivedetailsApi.deleteArchive(id, status)
            .then(function (response) {
                // console.log("deleteArchiveDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ARCHIVE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/archive/archive-meeting-list');
                }
                dispatch({ type: types.ADD_ARCHIVE_RESET });
            })
            .catch(function (err) {
                // console.log("deleteArchiveDetails action err", err)
                dispatch({ type: types.ADD_ARCHIVE_REQUEST_ERROR });
            });
    }
}

export function deleteArchiveFileDetails(id) {
    // console.log("deleteArchiveDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ARCHIVE_REQUEST });
        archivedetailsApi.deleteArchiveFile(id)
            .then(function (response) {
                // console.log("deleteArchiveDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ARCHIVE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    // history.push('/archive/archive-meeting-list');
                }
                dispatch({ type: types.ADD_ARCHIVE_RESET });
            })
            .catch(function (err) {
                // console.log("deleteArchiveDetails action err", err)
                dispatch({ type: types.ADD_ARCHIVE_REQUEST_ERROR });
            });
    }
}



// WEBPACK FOOTER //
// ./actions/archivedetails.js